import module from 'module';

import templateUrl from './compliance-list.template.html';
import './compliance-list.style.less';

class ComplianceListView {
  async $onInit() {
    this.options = [
      {name: 'Force profile update', url: '#!/admin/compliance/force-profile-update'},
      {name: 'Risk assessment', url: '#!/admin/compliance/risk/assessment'},
      {name: 'Risk profiling categories', url: '#!/admin/compliance/risk/categories'},
      {name: 'Watchlist', url: '#!/admin/compliance/watchlist'},
    ];
  }

  openUrl(option) {
    return option.url;
  }
}

module.component('complianceListView', {
  templateUrl,
  controller: ComplianceListView
});
